import cn from "classnames";
import styles from "./Details.module.sass";
import Icon from "../../../Icon";
import Overview from "./Overview";
import { downloadDocument, downloadProspectDocument } from "../../../../services/documents.service";

const Details = ({ className, setValue, documentData, isProspect = false }) => {
    return (
        <div className={cn(styles.details, className)}>
            <div className={styles.head}>
                <div className={styles.btns}>
                    <button 
                        className={cn("button-stroke", styles.buy)}
                        onClick={async () => {
                            if (documentData) {
                                try {
                                    console.log("Téléchargement du document:", documentData);
                                    const success = isProspect 
                                        ? await downloadProspectDocument(documentData)
                                        : await downloadDocument(documentData);
                                    if (!success) {
                                        console.error("Échec du téléchargement du document");
                                    }
                                } catch (error) {
                                    console.error("Erreur lors du téléchargement du document:", error);
                                }
                            }
                        }}
                    >
                        Télécharger
                        <Icon name="download" size="24" />
                    </button>
                </div>
            </div>
            <Overview documentData={documentData} isProspect={isProspect} />
     
        </div>
    );  
};

export default Details;
